import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { adhocDto } from 'src/app/models/adhocDto';
import { approveAddhoc } from 'src/app/models/approveAdhoc';
import { ContractPendingApprovalDto } from 'src/app/models/ContractPendingApprovalDto';
import { EmployeeDto } from 'src/app/models/EmployeeDto';
import { JobRotationResp } from 'src/app/models/jobRotation';
import { NotificationType } from 'src/app/models/notification.message';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';
import { LoginResponseData } from 'src/app/models/responses/login-response-data';
import { VendorDto } from 'src/app/models/VendorDto';
import { AdHocService } from 'src/app/services/ad-hoc.service';
import { ContractsService } from 'src/app/services/contracts.service';
import { EmployeesService } from 'src/app/services/employees.service';
import { JobRotationService } from 'src/app/services/job-rotation.service';
import { NotificationService } from 'src/app/services/notification.service';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';
import { TokenService } from 'src/app/services/token.service';
import { VendorsService } from 'src/app/services/vendors.service';

@Component({
  selector: 'app-view-job-rotations',
  templateUrl: './view-job-rotations.component.html',
  styleUrls: ['./view-job-rotations.component.css']
})
export class ViewJobRotationsComponent implements OnInit {

   ViewRequestVisible = false;
  ApproveRequest: adhocDto | any
  RequestApprovals: RequestApprovalDto[] | undefined;
  currentUser: any
  adhocs: JobRotationResp[] | undefined;

  Comment: string ='';
  
   isContractpprovalModalVisible = false;
    // ViewRequestVisible = false;
    isChangeNumVisible = false;
    isChangeOkLoading = false;
    isExpressApprovalModalVisible = false
    newNumOfStaffForm!: FormGroup;
    expressApprovalCommentForm!: FormGroup
    isReneweModalVisible = false;
    renewModalTitle:string ="Renew Contract";
    renewDuration:number=0;
    renewStartDate:Date = new Date();
    renewComment:string="";
    renewEndDate:string="";
    renewId:number=0;
    isLoadingRenew:boolean=false;
    Requests: adhocDto[] = [];
    Vendors: VendorDto[] = [];
    // RequestApprovals: RequestApprovalDto[] | undefined;
    ContractRequestApprovals: RequestApprovalDto[] | undefined;
    UpdateRequest: any;
    poNumber: string = '';
    poEntry: number = 0; //Used for entry to enable digit restriction
    contractorId: number = 0;
    approvedCost: number = 0;
    biometricRequired: boolean = false;
    safetyInductionNotes: string = '';
    medicalNotes: string = '';
  
    canUpdate: boolean = false;
    canPrint: boolean = false;
    canTerminate: boolean = false;
    editing: boolean = false;
    poAnswer: boolean = false;
    expressApprovalRequest: boolean = false;
  
    expressApprovalMessage: string = ''
  
    showCreatedByColumn: boolean = false;
    showFunctionColumn: boolean = false;
  
    // currentUser: any;
    filter: any
    today: Date = new Date();
    poDate: Date = new Date();
  
    terminateTitle: string = '';
    isTerminationVisible: boolean = false;
    terminationComment: string = '';
    terminationDate: Date = new Date();
    canChangeEmp: boolean = false;
    canCreateContract: boolean = false;
    actualStartDate: Date = new Date;
    canUpdatePO: boolean = false;
    canAddEmp:boolean=false;
    updatebtn:boolean=false;
    canRenewContract:boolean=false;
    isContractClosed:boolean=false;
    isCloseModalVisible:boolean=false;
    closeModalTitle:string ="";
    cancelComment:string="";
    isCancelVisible:boolean=false;

  constructor(private adhocService: AdHocService, private notification: NotificationService,
      private tokenService: TokenService, private requestApprovalService:RequestApprovalsService, 
      private router: Router, public employeeService:EmployeesService,  public datepipe: DatePipe,  private contractService: ContractsService,
          private vendorService: VendorsService, private jobRotationService: JobRotationService,
          private fb: FormBuilder ) { }

  ngOnInit(): void {
    this.filter = history.state.data;
    this.loadRecords(this.filter);

     this.newNumOfStaffForm = this.fb.group({
    
          numberOfStaff: [null, [Validators.required]],
          message: [null, [Validators.required]],
    
        });
        this.UserViews();
  }

  async loadRecords(filter: any) {
      ;
      this.currentUser = this.tokenService.getInfo(); 
      let email = this.currentUser.profile.email;
      let resContracts = await this.jobRotationService.getRotationReqsForCurrentUser(email).toPromise();
      this.adhocs = <JobRotationResp[]>resContracts.responseData;
      console.log('this is adhocs ', this.adhocs);
  
      if (filter == 'Active') {
      this.Requests = (this.Requests.filter(x => x.status === "Active"));
    }
    else if (filter == 'Pending') {
      this.Requests = (this.Requests.filter(x => x.status === "Pending"));
    }
    else if (filter == 'New') {
      this.Requests = (this.Requests.filter(x => x.status === "New"));
    }
    else if (filter == 'Approved') {
      this.Requests = (this.Requests.filter(x => x.status === "Approved"));
    }
    else if (filter == 'Rejected') {
      this.Requests = (this.Requests.filter(x => x.status === "Rejected"));
    }
    else if (filter == 'Completed') {
      this.Requests = (this.Requests.filter(x => x.status === "Completed"));
    }
    else if (filter == 'Expired') {
      this.Requests = (this.Requests.filter(x => x.status === "Expired"));
    }
    else if (filter == 'Pending_EA') {
      this.Requests = (this.Requests.filter(x => x.status === "Pending_EA"));
    }
    else if (filter == 'PendingPO') {
      this.Requests = (this.Requests.filter(x => x.poNumber == null && x.status === "Active"));
    }
    else if (filter == 'Expiring') {
      let today = new Date();
      // this.Requests = this.Requests.filter(x => today.getMonth() - (new Date(x.startDate).getMonth()) == x.contractDuration && (new Date(x.expectedStartDate).getFullYear()) == today.getFullYear() && (x.status === "Approved" || x.status === "Active"));
    }

    try {
      this.Requests?.sort((n1, n2) => {
        if (n1.id > n2.id) {
          return -1;
        }

        return 0;
      });
    } catch (error) {

    }

    this.currentUser = this.tokenService.getInfo();

    if (!(this.Requests[0].createdBy == this.currentUser.profile.email)) { this.showCreatedByColumn = true; }
    if (!(this.Requests[0].sectionOrDepartment == this.currentUser.profile.departmentName)) { this.showFunctionColumn = true; }

    }

    getStatusColor(status: string): string {
    switch (status) {
      case "New":
        return 'badge badge-warning';
      case "Pending":
        return 'badge badge-warning';
      case "Approved":
        return 'badge badge-success';
      case "Rejected":
        return 'badge badge-danger';
        case "Closed":
          return 'badge badge-danger';
          case "Cancelled":
            return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }

  }

  openExpressApprovalModal() {
    this.isExpressApprovalModalVisible = true;
  }

  sendExpressApproval() {
      if (this.expressApprovalMessage === '') {
        this.notification.sendMessage({
          message: 'Comment is required for express approval request',
          type: NotificationType.error
        });
      }
      else {
        this.isChangeOkLoading = true;
        let data = { id: this.UpdateRequest.id, message: this.expressApprovalMessage, }
        this.adhocService.requestExpressApproval(data).subscribe({
          next: (data => {
  
            if (data.responseCode == "00") {
              this.notification.sendMessage({
                message: `Request sent successfully `,
                type: NotificationType.success
              });
  
              this.isExpressApprovalModalVisible = false;
  
              this.close();
              this.loadRecords(this.filter);
  
              this.isChangeOkLoading = false;
            }
            else {
              this.isChangeOkLoading = false;
              this.notification.sendMessage({
                message: data.message,
                type: NotificationType.error
              });
              this.isChangeOkLoading = false;
            }
  
          }),
          error: ((error: any) => {
            this.notification.sendMessage({
              message: error.message,
              type: NotificationType.error
            });
            this.isChangeOkLoading = false;
          })
  
        });
      }
    }

  async openEmps(id:number)
    {
      
     // ;
      // let resApprovals = await this.employeeService.getByRequest(id,type).toPromise();
      // let employeeData = <EmployeeDto[]>resApprovals.responseData;
      // this.router.navigateByUrl("contractsemployees", {
      //   state: {data: employeeData}
    // });
  }


    close(): void {
    this.ViewRequestVisible = false;
    this.canPrint = false;
    this.canUpdate = false;
    this.editing = false;
    this.updatebtn=false;
    this.canUpdatePO=false;


  }

  // async open(data: adhocDto) {
    
  //       this.ViewRequestVisible = true;
    
  //       this.ApproveRequest = data;
  //       let resApprovals = await this.adhocService.getRequestApprovals(data.id).toPromise();
  //       this.RequestApprovals = <RequestApprovalDto[]>resApprovals.responseData;
    
  //     }

  async open(data: JobRotationResp) 
    {
      ;
      this.ViewRequestVisible = true;
  
      let resApprovals = await this.jobRotationService.getRequestApprovals(data.id).toPromise();
      this.RequestApprovals = <RequestApprovalDto[]>resApprovals.responseData;
   
  // if( data.poNumber)
  // {
  //   this.poNumber = data.poNumber;
  //   this.poEntry=+data.poNumber;
  // }
   
      this.UpdateRequest = data;
      this.contractorId = data.id;

      // this.poDate=data.poDate;
  
      if (data.status === "Approved") { this.canUpdate = true; this.canPrint = true }
  
      ;
      if ( this.canAddEmp===true) 
      {
        var status = this.UpdateRequest?.status;
        if ( status === 'Active' || status === 'Approved') {
          //this.canUpdatePO = true;
          this.updatebtn=true;
  
        }
        else
        {
          //this.canUpdatePO = false;
          this.updatebtn=false;
  
        }
      }
  
      // if (data.status === "Active") { this.canPrint = true; this.canTerminate = true }
  
    }

    async openPendingApprovals(data: JobRotationResp) 
      {
        ;
    
        //this.UpdateRequest = data;
        this.UpdateRequest = data;
        let resApprovals = await this.jobRotationService.getRequestApprovals(data.id).toPromise();
        this.ContractRequestApprovals = <RequestApprovalDto[]>resApprovals.responseData;
        console.log('this is the approvals ', this.ContractRequestApprovals);
        this.isContractpprovalModalVisible = true;
        // if (data.status === "Active") { this.canPrint = true; this.canTerminate = true }
    
      }

       cancelRequest(){

    ;
    this.isChangeOkLoading=true;
    if (this.cancelComment === '') 
    {
      this.notification.sendMessage({
        message: 'Comment is required to close request',
        type: NotificationType.error
      });
      this.isChangeOkLoading=false;
    }
    else {
      this.isChangeOkLoading = true;
      const data =
      {
        id: this.UpdateRequest.id,
        message: this.cancelComment,
 

      }

      this.contractService.CancelRequest(data).subscribe({
        next: (data => {
          if (data.responseCode == "00") {
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.success
            });
            this.loadRecords(this.filter)
            this.isTerminationVisible = false;
            this.close()
          }
          else {

            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.error
            });

            this.isChangeOkLoading = false;
          }

        }),
        error: ((error: any) => {
          console.log(error.error);

          this.notification.sendMessage({
            message: error.error.message,
            type: NotificationType.error
          });

          this.isChangeOkLoading = false;
        })

      });}

  }
  sendRenewRequest()
  {
    if (this.renewComment === '') 
    {
      this.notification.sendMessage({
        message: 'Comment is required for Contract Renewal requests',
        type: NotificationType.error
      });

      return;
    }
    if(this.renewDuration <= 0)
    {

      this.notification.sendMessage({
        message: 'Invalid duration entered',
        type: NotificationType.error
      });

      return;
    }
    this.isChangeOkLoading = true;
    let data = { id: this.renewId, comment: this.renewComment,duration:this.renewDuration, startDate:this.renewStartDate }
    this.adhocService.RenewContract(data).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          this.isLoadingRenew=false;
          this.isReneweModalVisible = false;
        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;
       

        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }
  onchangeforEndDate(theduration: number) {
  
    ;
    var renewdat = new Date();
    renewdat=  this.renewStartDate;
    var newDate = new Date(renewdat.setMonth(renewdat.getMonth()+theduration));

    let latest_date =this.datepipe.transform(newDate, 'yyyy-MM-dd');
    this.renewEndDate = latest_date!;
  }

  async beginEdit() {
    ;
    this.canPrint = false;
    this.editing = true;
    this.updatebtn=false;
    this.canUpdatePO=true;

    let resVendors = await this.vendorService.getVendors().toPromise();
    this.Vendors = <VendorDto[]>resVendors.responseData;
  }

  async beginRenew(data: adhocDto) 
    {
      this.renewModalTitle="Reneww Contract for : " + data.contractorName;
      this.renewId = data.id;
       this.isReneweModalVisible = true;
  
    }
  
    async beginClose(data: adhocDto) 
    {
      this.closeModalTitle="Close Contract for : " + data.contractorName;
      this.renewId = data.id;
       this.isCloseModalVisible = true;
       this.isTerminationVisible = true;
       this.UpdateRequest=data;
  
    }
  
    async beginCancel(data: adhocDto) 
    {
      
      this.closeModalTitle="Cancel Contract ";
      this.renewId = data.id;
       this.isCloseModalVisible = true;
       this.isCancelVisible = true;
     this.UpdateRequest=data;
    }

   update(): void {

    this.UpdateRequest.contractorId = this.contractorId;
    this.UpdateRequest.poNumber = this.poEntry.toString();
    this.UpdateRequest.approvedCost = this.approvedCost
    this.UpdateRequest.actualStartDate = this.actualStartDate;
    this.UpdateRequest.poDate = this.poDate;
    this.UpdateRequest.safetyInductionNotes = this.safetyInductionNotes;
    //  this.UpdateRequest.isBiometricRequired = this.biometricRequired;
    // this.UpdateRequest.safetyInductionNotes = this.safetyInductionNotes;
    // this.UpdateRequest.medicalNotes = this.medicalNotes

    this.adhocService.updatePONumber(this.UpdateRequest).subscribe({
      next: (data => {

        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: `Request updated successfully `,
            type: NotificationType.success
          });

          this.close();
         // window.location.reload();
         ;
         this.filter = history.state.data;
         this.loadRecords(this.filter);
        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);



        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });


  }

   print() {
    window.print();
  }

  openChangeNoModal() {
    this.isChangeNumVisible = true;

  }

   handleCancel(): void {
    this.isChangeNumVisible = false;
    this.isExpressApprovalModalVisible = false;
    this.isTerminationVisible = false;
    this.isReneweModalVisible = false;
    this.isCancelVisible = false;
    this.isContractpprovalModalVisible = false

  }

   handleOk(): void {

    this.isChangeOkLoading = true;
    setTimeout(() => {
      this.isChangeNumVisible = false;
      this.isChangeOkLoading = false;
    }, 3000);
  }

  submitForm(): void {
    if (this.newNumOfStaffForm.valid) {



      const obj = {
        id: this.UpdateRequest.id,
        newCount: this.newNumOfStaffForm.get('numberOfStaff')?.value,
        message: this.newNumOfStaffForm.get('message')?.value,

      };


       let currentNumber:number =this.UpdateRequest?.noOfStaff;
       if(obj.newCount<= currentNumber)
       {
        this.notification.sendMessage({
          message: "Invalid number entered",
          type: NotificationType.error
        });
        return;

       }

      this.adhocService.ChangeNoOfEmployees(obj).subscribe({
        next: (data => {
          
          if (data.responseCode == "00") {
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.success
            });
            this.isChangeNumVisible = false;
            this.newNumOfStaffForm.reset();


          }
          else {

            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.error
            });
            this.isChangeNumVisible = false;
          }

        }),
        error: ((error: any) => {

          this.notification.sendMessage({
            message: error.error.message,
            type: NotificationType.error
          });
        })

      });




    } else {
      Object.values(this.newNumOfStaffForm.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  downloadExcel() {
  //     const exportData: Partial<object>[] = this.Requests.map(
  //       x => ({
  //         Reference: x.reference,
  //         Requester: x.createdBy,
  //         RequestDate: x.createdDate,
  //         Department: x.departmentName,
  //         Location: x.locationName,
  //         CostCenter: x.costCenterName,
  //         Contractor: x.contractorName,
  //         Description: x.description,
  //         Justification: x.justification,
  //         Qualification: x.qualification,
  //         NumberOfStaff: x.noOfStaff,
  //         ActiveStaff: x.numberofActiveEmployees,
  //         ExpectedStartDate: x.expectedStartDate,
  //         BudgetCost: x.budgetCost,
  //         ApprovedCost: x.approvedCost,
  //         PONumber: x.poNumber,
  //         ExpressApprovalRequired: x.expressApprovalRequired ? 'Yes' : 'No',
  //         ExpressApprovalReason: x.expressApprovalRequesterMessage,
  //         ExpressApprovalRequestDate: x.expressApprovalRequestDate,
  //         ExpressApprovalStatus: x.expressApprovalStatus,
  //         ExpressApprovalResponse: x.expressApproverMessage,
  //         ExpressApprovalResponseDate: x.expressApprovalApproveDate,
  //         SafetyInductionNotes: x.safetyInductionNotes,
  //         MedicalNotes: x.medicalNotes,
  //         Status: x.isActive ? 'Active' : 'Inactive',
  
  //       })
  //     );
  //     ExcelexportService.exportArrayToExcel(exportData, 'Request Export')
    }

  openTerminate() {
    this.isTerminationVisible = true;
    this.terminateTitle = "Terminate Request: " + this.UpdateRequest.reference;
  }

  onChangeTerminationDate(result: Date): void {
    this.terminationDate = result;
  }

  terminateRequest() {
    if (this.terminationComment === '') {
      this.notification.sendMessage({
        message: 'Comment is required to close request',
        type: NotificationType.error
      });
    }
    else {
      this.isChangeOkLoading = true;
      const data =
      {
        id: this.UpdateRequest.id,
        message: this.terminationComment,
        enddate: this.terminationDate,

      }

      this.adhocService.terminateRequest(data).subscribe({
        next: (data => {
          if (data.responseCode == "00") {
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.success
            });
            this.loadRecords(this.filter)
            this.isTerminationVisible = false;
            this.close()
          }
          else {

            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.error
            });

            this.isChangeOkLoading = false;
          }

        }),
        error: ((error: any) => {
          console.log(error.error);

          this.notification.sendMessage({
            message: error.error.message,
            type: NotificationType.error
          });

          this.isChangeOkLoading = false;
        })

      });
    }
  }

    
    
      // close(): void {
      //   this.ViewRequestVisible = false;
      // }
    
      cancel(): void {
     return;
      }
     
      confirm(): void {
        alert('click confirm');
      }

       async approveContract() {
          
          const model: approveAddhoc = { id: this.ApproveRequest.id, message: this.Comment  };
      
        console.log('this is the payload', model);
      
            this.adhocService.approveContract(model).subscribe({
              next: (data => {
                
                if (data.responseCode == "00") {
                  this.notification.sendMessage({
                    message: data.message,
                    type: NotificationType.success
                  });
      
                  this.loadRecords(this.filter);
                  this.close()
                }
                else {
      
                  this.notification.sendMessage({
                    message: data.message,
                    type: NotificationType.error
                  });
      
                }
      
              }),
              error: ((error: any) => {
                console.log(error.error);
                ;
      
      
                this.notification.sendMessage({
                  message: error.error.message,
                  type: NotificationType.error
                });
              })
      
            });
      
        }
      
        async rejectContract() {
      
          if (this.Comment === '') {
            this.notification.sendMessage({
              message: 'Comment is required when rejecting request',
              type: NotificationType.error
            });
          }
          else {
            
      
              this.close();
      
               
        
      
              const model: approveAddhoc = { id: this.ApproveRequest.id, message: this.Comment };
      
              this.adhocService.rejectContract(model).subscribe({
                next: (data => {
      
                  if (data.responseCode == "00") {
                    this.notification.sendMessage({
                      message: data.message,
                      type: NotificationType.success
                    });
      
                    this.loadRecords(this.filter);
                    this.close();
                  }
                  else {
      
                    this.notification.sendMessage({
                      message: data.message,
                      type: NotificationType.error
                    });
      
                  }
      
                }),
                error: ((error: any) => {
                  console.log(error.error);
                  ;
      
      
                  this.notification.sendMessage({
                    message: error.error.message,
                    type: NotificationType.error
                  });
                })
      
              });
          
          }
        }

        UserViews(): void {
        
            try {
        
              ;
              const userData: LoginResponseData = this.tokenService.getInfo();
              var UserPermission = userData.permission;
        
              const ContractPerm = UserPermission.find((obj) => {
                return obj.permissionName === "Contracts";
              });
        
              if (ContractPerm) {
                this.canCreateContract = ContractPerm.canAdd === true ? true : false;
                this.canChangeEmp = ContractPerm.canAdd === true ? true : false;
                this.canTerminate = ContractPerm.canTerminate === true ? true : false;
                this.canAddEmp = ContractPerm.canEdit === true ? true : false;
                this.canRenewContract = ContractPerm.canEdit === true ? true : false;
                if ( this.canAddEmp) {
                 
                  if (this.UpdateRequest?.status === 'Active' || this.UpdateRequest?.status === 'Approved') {
                   // this.canUpdatePO = true;
                    this.updatebtn=true;
        
                  }
                }
              }
        
        
            }
            catch (e: unknown) { }
        
        
          }


}
